export default {
  layouts: {
    alifshop: {
      orders: 'Buyurtmalar',
    },
  },
};
